import { get } from 'lodash';

export const getObjectName = (option) => get(option, 'name');
